import { closeRaiseTicket, openRaiseTicket } from '../modules/hr-desk/tickets/raiseStore.ts'
import { clickFirst, registerTour, tourTarget, waitForElement } from './registry.ts'

/** Whether this tour opened the Raise modal (so it closes only what it opened). */
let openedModal = false
const openModal = async () => {
  if (!document.querySelector(tourTarget('raise-category'))) {
    openRaiseTicket()
    openedModal = true
  }
  await waitForElement(tourTarget('raise-category'))
}
const closeModal = () => {
  if (openedModal) closeRaiseTicket()
  openedModal = false
}

registerTour({
  id: 'employee-raise',
  title: 'Raise and track a ticket',
  summary: 'Ask HR for help and follow it to the end',
  roles: ['member'],
  path: '/hr/my-tickets',
  autoStart: true,
  order: 10,
  onExit: closeModal,
  steps: [
    {
      element: tourTarget('raise-ticket'),
      prepare: closeModal,
      popover: {
        title: 'Raise a ticket',
        description: 'Start here whenever you need HR. The button is on every page.',
        side: 'bottom',
        align: 'end',
      },
    },
    {
      element: tourTarget('raise-category'),
      prepare: openModal,
      popover: {
        title: 'What it’s about',
        description:
          'Pick a category. The description box then suggests what HR needs to know, like the amount and date for a reimbursement.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: tourTarget('raise-priority'),
      prepare: openModal,
      popover: {
        title: 'How urgent is it?',
        description:
          'The line below the pills says how quickly HR aims to resolve it. HR may adjust the priority after reviewing.',
        side: 'top',
        align: 'start',
      },
    },
    {
      element: tourTarget('attach-drop'),
      prepare: openModal,
      popover: {
        title: 'Attach receipts',
        description:
          'Add screenshots, receipts or documents. Only people who can see the ticket can open them.',
        side: 'top',
        align: 'start',
      },
    },
    {
      element: tourTarget('raise-confidential'),
      prepare: openModal,
      popover: {
        title: 'Keep it confidential',
        description:
          'Tick this for anything sensitive: only HR leads and the HR partner handling it will see the ticket. Grievances are confidential by default.',
        side: 'top',
        align: 'start',
      },
    },
    {
      element: tourTarget('my-ticket-row'),
      prepare: closeModal,
      popover: {
        title: 'Follow its progress',
        description:
          'Each ticket shows its status, who is handling it and when HR expects to finish. “HR is waiting for your reply” means it’s your turn.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: tourTarget('ticket-comments'),
      prepare: async () => {
        closeModal()
        if (!document.querySelector(tourTarget('ticket-comments')))
          await clickFirst(tourTarget('my-ticket-row'))
      },
      popover: {
        title: 'Talk to HR',
        description:
          'Open a ticket to add comments. Replying while HR waits sends it straight back to them, and a resolved ticket has a Reopen button if it isn’t sorted.',
        side: 'top',
        align: 'start',
      },
    },
  ],
})
